import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh', display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center', padding: '24px',
          fontFamily: "'Outfit', sans-serif", background: '#fafaf9', textAlign: 'center'
        }}>
          <img src="/logo-taverne.png" alt="La Taverne" style={{ width: 200, marginBottom: 24 }} />
          <h1 style={{ fontSize: 22, color: '#3d2817', marginBottom: 8, fontFamily: "'Cormorant Garamond', serif" }}>
            Oops, une erreur est survenue
          </h1>
          <p style={{ fontSize: 14, color: '#78716c', marginBottom: 24, maxWidth: 320 }}>
            Veuillez rafraichir la page. Si le probleme persiste, videz le cache de votre navigateur.
          </p>
          <button
            onClick={() => { window.location.reload(); }}
            style={{
              background: '#8B0000', color: '#fff', border: 'none', padding: '12px 32px',
              fontSize: 13, letterSpacing: '0.1em', textTransform: 'uppercase', cursor: 'pointer'
            }}
          >
            Rafraichir la page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
